/*
 * Copyright (c) 2025 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import ArgosDialog from "../../../../../../components/Dialogs/ArgosDialog"
import ArgosFlexbox from "../../../../../../components/Containers/ArgosFlexbox";
import {Typography} from "@mui/material";
import ArgosButton from "../../../../../../components/Buttons/ArgosButton";

interface IProps {
  open: boolean;
  message: string;
  onClose: () => void;
  onConfirm: () => void;
}

const GeneralWarningDialog = (props: IProps) => {

  return (
    <>
      <ArgosDialog
        height={'auto'}
        width={'auto'}
        open={props.open}
        headerTitle={'Warning'}
        headerTitleAlign={'left'}
      >
        <ArgosFlexbox vertical style={{padding: '20px'}}>
          <ArgosFlexbox vertical style={{padding: '20px'}}>
            <Typography variant='body1'>
              {props.message}
            </Typography>
          </ArgosFlexbox>
          <ArgosFlexbox style={{display: 'flex', flexDirection: 'row', padding: '10px'}}>
            <ArgosButton
              id={`cancel-button`}
              data-testid={`cancel-button`}
              variant="contained"
              size="large"
              fontSize={16}
              onClick={props.onClose}
            >
              Cancel
            </ArgosButton>
            <ArgosButton
              id={`confirm-button`}
              data-testid={`confirm-button`}
              variant="text"
              size="large"
              fontSize={16}
              onClick={props.onConfirm}
            >
              Confirm
            </ArgosButton>
          </ArgosFlexbox>
        </ArgosFlexbox>
      </ArgosDialog>
    </>
  )
}

export default GeneralWarningDialog